import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import service from '../service';
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { AttendanceDonwnloadSchema } from "../AttendanceDonwnloadSchema";
import { validateProperty, validate } from "../../../Common";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import TableCell from '@material-ui/core/TableCell';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';

const screenCode = 'ATTENDANCEDOWNLOADREPORT'

export function AttendanceDonwnloadReport(props) {

    const componentRef = useRef();
    const [attendanceDownloadData, setAttendanceDownloadData] = useState([])
    const [attendanceDownloadDataSearchValues, setAttendanceDownloadDataSearchValues] = useState({
        fromDate: "",
        toDate: ""
    })

    attendanceDownloadData.forEach(x => {
        let crop = '';
        x.crop = 'Tea'
    })

    const pdfRef = React.createRef();

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [buttonHide, setButtonHide] = useState(true);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const csvHeaders = [
        { label: 'Location', value: 'operationEntityName' },
        { label: 'field', value: 'fieldName' },
        { label: 'Job', value: 'narration' },
        { label: 'Transaction Division', value: 'collectionPointName' },
        { label: 'Employee No', value: 'employeeCode' },
        { label: 'Crop', value: 'crop' },
        { label: 'Attendance Date', value: 'createdDate', render: rowData => rowData.createdDate.split('T')[0] },
        { label: 'Full Half', value: 'fullHalf' },
        { label: 'Work Type', value: 'employeeTypeID' },
        { label: 'Quentity', value: 'totalAmount' },
    ];

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const schema = Joi.object(AttendanceDonwnloadSchema).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    function handleSearchFromDateChange(target) {
        validateInputs(target);

        setAttendanceDownloadDataSearchValues({
            ...attendanceDownloadDataSearchValues,
            fromDate: target.value,
        });
    }

    function handleSearchToDateChange(target) {
        validateInputs(target);

        setAttendanceDownloadDataSearchValues({
            ...attendanceDownloadDataSearchValues,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, AttendanceDonwnloadSchema);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWATTENDANCEDOWNLOADREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

    }

    async function handleSearch(e) {

        e.preventDefault();
        setButtonHide(true);
        const errorMessages = validate(schema, attendanceDownloadDataSearchValues);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const attendanceList = await service.getReportData(attendanceDownloadDataSearchValues);

        setAttendanceDownloadData(attendanceList);
        setCsvData(attendanceList);
    }

    function createFile() {
        var settings = {
            sheetName: 'Attendance Download',
            fileName: 'AttendanceDownload',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(attendanceDownloadData);

        var newRow1 = {
            operationEntityName: "From Date : " + attendanceDownloadDataSearchValues.fromDate,
        }
        var newRow2 = {
            operationEntityName: "To Date : " + attendanceDownloadDataSearchValues.toDate,
        }
        copyOfCsv.push({}, newRow1, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Attendance Download "
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleSearchFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-6">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleSearchToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>


                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>
                            {attendanceDownloadData.length != 0 ?
                                <div style={{ width: '1400px' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Location
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Feild
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Job
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Transaction Divisions
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Employee No
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Crop
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Attendance Date
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Full Half
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Work Type
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Quantity
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {attendanceDownloadData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                                    <TableRow key={i}>
                                                                        <TableCell component="th" align="center" >
                                                                            {row.operationEntityName}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.fieldName}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.narration}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.collectionPointName}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.employeeCode}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.crop}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.createdDate.split('T')[0]}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.fullHalf}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.employeeTypeID}
                                                                        </TableCell>
                                                                        <TableCell colSpan={2} align="center" >
                                                                            {row.totalAmount}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                        <TablePagination
                                                            component="div"
                                                            count={attendanceDownloadData.length}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handleLimitChange}
                                                            page={page}
                                                            rowsPerPage={limit}
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                        />
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                        {attendanceDownloadData.length != 0 ?
                            <div className="pt-2">
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                                <ReactToPrint
                                    documentTitle={"Attendance Download"}
                                    trigger={() => <input
                                        type="submit"
                                        className="btn btn-primary pull-right ml-2"
                                        value="PDF"
                                    />}
                                    content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef}
                                        attendanceDownloadData={attendanceDownloadData} attendanceDownloadDataSearchValues={attendanceDownloadDataSearchValues}
                                    />
                                </div>
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


